import React from "react";

function PopupFinDePartie({ message, onRejouer, onRetour }) {
    return (
        <div className="popup-fin-partie">
            <div className="popup-contenu">
                <h2>{message}</h2>
                <div className="boutons-action">
                    <button onClick={onRejouer}>🔁 Rejouer</button>
                    <button onClick={onRetour}>📜 Liste des murs</button>
                </div>
            </div>
        </div>
    );
}

export default PopupFinDePartie;